module.exports = __webpack_public_path__ + "912dc533cd2ed5a2e452ed73c085efbf.svg";